import { AccountSelect } from '@components'

import { Divider, FormItem, Input, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AccountDescriptionFormItem,
  AccountNameFormItem,
  AccountNumberFieldLabel,
} from '../../../AccountFromTemplateFormFields'
import { RequiredFieldLabel } from '../../../RequiredFieldLabel'
import { useUpdateAccountFromTemplateForm } from '../../contexts'

export const UpdateAccountFromTemplateForm = (): ReactElement => {
  const { t } = useTranslation()
  const { accountNumber, excludedAccountIds, Form, selectedBaseAccountId } = useUpdateAccountFromTemplateForm()

  return (
    <Form>
      {/* Read-only display, not a real form field - base account never changes and is never submitted */}
      <FormItem
        label={<RequiredFieldLabel>{t('coa.account_from_base_form.base_account')}</RequiredFieldLabel>}
        name="baseAccount"
      >
        {({ id }) => (
          <AccountSelect
            disabled
            dropdownSize="fitTrigger"
            excludedAccounts={excludedAccountIds}
            id={id}
            selectedId={selectedBaseAccountId}
            size="sm"
          />
        )}
      </FormItem>

      <Space size="s24" />
      <Divider />
      <Space size="s24" />

      {/* Read-only display, not a real form field - account number never changes and is never submitted */}
      <FormItem
        extra={t('coa.account_from_base_form.account_number.edit_caption')}
        label={<AccountNumberFieldLabel disabled isManualEntryEnabled={false} />}
        name="accountNumber"
      >
        {({ id }) => <Input disabled id={id} size="sm" type="number" value={accountNumber ?? ''} />}
      </FormItem>

      <Space size="s24" />

      <AccountNameFormItem />

      <Space size="s24" />

      <AccountDescriptionFormItem />
    </Form>
  )
}
